var map = {
	"./1.png": 5470,
	"./2.png": 2602,
	"./3.png": 9608,
	"./4.png": 7977,
	"./5.png": 3336,
	"./6.png": 6950,
	"./7.png": 5845,
	"./8.png": 4993,
	"./old_1.png": 3134,
	"./old_2.png": 8943,
	"./old_3.png": 7060,
	"./old_4.png": 9947,
	"./old_5.png": 2752,
	"./old_6.png": 5221,
	"./old_7.png": 8339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8150;